// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f497869c","538":"4e68699f","648":"956075be","919":"d15a9e21"}[chunkId] + ".chunk.js";
};